import {
  Component,
  Input,
  HostBinding,
  ChangeDetectionStrategy,
  ViewChildren,
  QueryList,
  AfterContentChecked,
  ContentChildren,
} from '@angular/core';
import { MenuItem } from '@app/core/models';
import { RefreshItemLinkDirective } from './refresh-item-link.directive';

@Component({
  selector: 'ecp-refresh-item',
  templateUrl: './refresh-item.component.html',
  styleUrls: ['./refresh-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RefreshItemComponent implements AfterContentChecked {
  @HostBinding('class.nav__item') nav__item = true;
  @Input() label: string;
  @Input() title: string;
  @Input() icon: string[];
  @Input() link: string;
  @Input() fragment: string;
  @Input() ext: boolean;
  @Input() children: MenuItem[] = [];

  @ContentChildren(RefreshItemLinkDirective)
  contentLinks: QueryList<RefreshItemLinkDirective>;

  @ViewChildren(RefreshItemLinkDirective) links: QueryList<RefreshItemLinkDirective>;

  @HostBinding('class.is-active') hasActiveLinks = false;

  constructor() {}

  get grouped(): boolean {
    return this.children.some((item) => !item.link);
  }

  ngAfterContentChecked(): void {
    this.checkLinks();
  }

  checkLinks(): void {
    if (!this.links) return;

    this.hasActiveLinks = [...this.links.toArray(), ...this.contentLinks.toArray()].some((link) => {
      return link.element.nativeElement.classList.contains('is-active');
    });
  }
}
